import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui';
import { BaseButton, ModalX } from '../../../../../BaseComponents';
import { useTheme } from '../../../../../theme';
import { useToggleable } from '../../../../../hooks';
import { useIsTablet } from '../../../../../utils';
import { useSortings } from './hooks';
import { Filter, List } from '@shared/ui';
const Sortings = ({ currentSort, onSelect }) => {
    const { t } = useTranslation('Results');
    const { Sortings: css } = useTheme('Results');
    const { isOpen, open, close } = useToggleable(false);
    const isTablet = useIsTablet();
    const { sortingOptions, currentSorting } = useSortings(currentSort);
    const renderSorting = (React.createElement(Filter, { variant: "dropdown", options: sortingOptions, value: currentSorting, onChange: option => onSelect(+option.value), name: `${t('Sort by')}: ` }));
    const onModalSelect = (option) => {
        onSelect(+option.value);
        setTimeout(close, 500);
    };
    if (isTablet) {
        return (React.createElement(React.Fragment, null,
            React.createElement(BaseButton, { variant: "smallBrand", onClick: open },
                React.createElement(CdnIcon, { icon: "Action/Filter" })),
            React.createElement(ModalX, { isOpen: isOpen, onClose: close, classes: {
                    closeButton: css.modal__closeButton
                } },
                React.createElement(List, { className: css.sorting__list, options: sortingOptions, value: currentSorting, onChange: onModalSelect }))));
    }
    return React.createElement("div", { className: css.sorting__wrapper }, renderSorting);
};
export default Sortings;
